import Vue from 'vue'
import Router from 'vue-router'
import about from '@/components/pages/about'
import blog from '@/components/pages/blog'
import developer from '@/components/pages/developer'
import imprint from '@/components/pages/imprint'
import infosophy from '@/components/pages/blog/infosophy'

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'About',
    component: about
  },
  {
    path: '/blog',
    name: 'Blog',
    component: blog
  },
  {
    path: '/blog/infosophy',
    name: 'Infosophy',
    hideFromMenu: true,
    component: infosophy
  },
  {
    path: '/developer',
    name: 'Developer',
    component: developer
  },
  {
    path: '/imprint',
    name: 'Imprint',
    component: imprint
  }
];

export default new Router({
  mode: 'history',
  routes,
  linkActiveClass: 'nav-link--active'
})



// WEBPACK FOOTER //
// ./src/router/index.js